"use client";

import { ArrowRight, Hop } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ClearTheChaosWithJoeGio() {
  const eyebrow = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const headingLine1 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const headingLine2 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const paragraph = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.1
  });
  const ctas = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const imageReveal = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  const chipReveal = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  return <section data-section-id="5288" id="clear-the-chaos-with-joe-gio" className="relative min-h-screen w-full overflow-hidden bg-background dark">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-gradient-to-br from-background via-background to-secondary/20" />
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.03] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")"
    }} />

      <div className="relative mx-auto max-w-[1440px] px-6 pt-24 pb-20 sm:px-10 md:pt-32 lg:px-16 lg:pt-40 lg:pb-28">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-10 xl:gap-16">
          {}
          <div className="order-2 flex flex-col justify-center lg:order-1 lg:col-span-7">
            {}
            <div ref={eyebrow.ref} className="mb-8 flex items-center gap-3 transition-all duration-700 ease-out" style={{
            opacity: eyebrow.isVisible ? 1 : 0,
            transform: eyebrow.isVisible ? "translateY(0)" : "translateY(12px)"
          }}>
              <span className="h-px w-8 bg-primary" />
              <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-primary">
                [ 01 // THE MISSION ]
              </span>
            </div>

            {}
            <h1 className="font-default font-extrabold text-foreground" style={{
            fontSize: "clamp(56px, 9vw, 144px)",
            lineHeight: 0.9,
            letterSpacing: "-0.04em"
          }}>
              <span ref={headingLine1.ref} className="block overflow-hidden">
                <span className="block transition-all duration-[900ms] uppercase" style={{
                transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
                transform: headingLine1.isVisible ? "translateY(0)" : "translateY(100%)",
                opacity: headingLine1.isVisible ? 1 : 0
              }}>
                  Clear the chaos,
                </span>
              </span>
              <span ref={headingLine2.ref} className="block overflow-hidden">
                <span className="block transition-all duration-[900ms] uppercase !text-[rgba(6,29,249,1)]" style={{
                color: "hsl(24 95% 50%)",
                transitionDelay: "120ms",
                transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
                transform: headingLine2.isVisible ? "translateY(0)" : "translateY(100%)",
                opacity: headingLine2.isVisible ? 1 : 0
              }}>
                  haul it all.
                </span>
              </span>
            </h1>

            {}
            <p ref={paragraph.ref} className="font-default mt-10 max-w-[60ch] text-[20px] leading-relaxed text-muted-foreground transition-all duration-700" style={{
            opacity: paragraph.isVisible ? 1 : 0,
            transform: paragraph.isVisible ? "translateY(0)" : "translateY(16px)",
            transitionDelay: "400ms"
          }}>
              Professional junk removal and site clearing for Fort Worth and beyond. 
              Joe & Gio deliver high-performance logistics to reclaim your space 
              with industrial-grade efficiency.
            </p>

            {}
            <div ref={ctas.ref} className="mt-10 flex flex-col items-start gap-5 transition-all duration-700 sm:flex-row sm:items-center" style={{
            opacity: ctas.isVisible ? 1 : 0,
            transform: ctas.isVisible ? "translateY(0)" : "translateY(16px)",
            transitionDelay: "560ms"
          }}>
              <Link to="/HomePage">
                <Button size="lg" className="font-default h-14 rounded-md bg-primary px-8 text-[15px] font-bold tracking-wide text-primary-foreground shadow-md hover:bg-primary/90 transition-transform hover:-translate-y-1">
                  BOOK YOUR HAUL
                </Button>
              </Link>
            </div>
          </div>

          {}
          <div className="order-1 lg:order-2 lg:col-span-5">
            <div ref={imageReveal.ref} className="relative transition-all duration-[1400ms] ease-out" style={{
            opacity: imageReveal.isVisible ? 1 : 0,
            transform: imageReveal.isVisible ? "scale(1)" : "scale(1.08)",
            transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)"
          }}>
              <div className="relative w-full overflow-hidden rounded-md shadow-2xl border border-border" style={{
              aspectRatio: "4 / 5",
              borderRadius: "0px"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695455/img/trailer_no_people.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695455/img/trailer_no_people.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695455/img/trailer_no_people.png-wvc-sizes" alt="Industrial junk removal trailer without people" className="h-full w-full object-contain grayscale-[0.2] contrast-125" loading="lazy" decoding="async" src="https://loving-tarpon.10web.cloud/wp-content/uploads/2026/06/7401EEFB-C07E-4718-8571-2DE1C052DF59.png" />
                {}
                <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-t from-background/60 via-transparent to-transparent" />
              </div>

              {}
              <div ref={chipReveal.ref} className="absolute -bottom-6 -left-4 transition-all duration-700 sm:-left-6 md:-bottom-8 md:-left-8" style={{
              opacity: chipReveal.isVisible ? 1 : 0,
              transform: chipReveal.isVisible ? "translateY(0)" : "translateY(20px)",
              transitionDelay: "900ms"
            }}>
                <div className="flex items-center gap-3 rounded-md bg-secondary px-4 py-3 shadow-xl sm:px-5 sm:py-4 border border-primary/30">
                  <div className="flex size-9 items-center justify-center rounded-md bg-primary">
                    <Hop className="size-4 text-primary-foreground" />
                  </div>
                  <div className="flex flex-col">
                    <span className="font-mono text-[11px] uppercase tracking-[0.16em] text-primary" style={{
                    fontVariantNumeric: "tabular-nums"
                  }}>
                      EST. 2024
                    </span>
                    <span className="font-default text-[14px] font-bold text-foreground uppercase">
                      Heavy Duty · Fast · Reliable
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="mt-24 flex flex-col items-center gap-3 md:mt-32">
          <div className="relative h-12 w-px overflow-hidden bg-primary/30">
            <span className="absolute left-0 top-0 h-6 w-px bg-primary" style={{
            animation: "blazeScrollLine 2.2s cubic-bezier(0.65, 0, 0.35, 1) infinite"
          }} />
          </div>
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
            Deploy
          </span>
        </div>
      </div>

      <style>{`
        @keyframes blazeScrollLine {
          0% { transform: translateY(-100%); }
          60% { transform: translateY(200%); }
          100% { transform: translateY(200%); }
        }
      `}</style>
    </section>;
}